import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _53833c44 = () => interopDefault(import('../pages/Compliance.vue' /* webpackChunkName: "pages/Compliance" */))
const _21f22947 = () => interopDefault(import('../pages/Contact.vue' /* webpackChunkName: "pages/Contact" */))
const _73169d9f = () => interopDefault(import('../pages/Controls.vue' /* webpackChunkName: "pages/Controls" */))
const _0979f73c = () => interopDefault(import('../pages/Customers.vue' /* webpackChunkName: "pages/Customers" */))
const _307e37c2 = () => interopDefault(import('../pages/Documents.vue' /* webpackChunkName: "pages/Documents" */))
const _63f252d6 = () => interopDefault(import('../pages/KnowledgeBase.vue' /* webpackChunkName: "pages/KnowledgeBase" */))
const _68fc9110 = () => interopDefault(import('../pages/my-questionnaires.vue' /* webpackChunkName: "pages/my-questionnaires" */))
const _78f32ae2 = () => interopDefault(import('../pages/Overview.vue' /* webpackChunkName: "pages/Overview" */))
const _1196a815 = () => interopDefault(import('../pages/SearchResults.vue' /* webpackChunkName: "pages/SearchResults" */))
const _2e537f28 = () => interopDefault(import('../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _c1d86c70 = () => interopDefault(import('../pages/Subprocessors.vue' /* webpackChunkName: "pages/Subprocessors" */))
const _0b89be46 = () => interopDefault(import('../pages/Team.vue' /* webpackChunkName: "pages/Team" */))
const _0340fe1e = () => interopDefault(import('../pages/Updates.vue' /* webpackChunkName: "pages/Updates" */))
const _2048d71a = () => interopDefault(import('../pages/UploadQuestions.vue' /* webpackChunkName: "pages/UploadQuestions" */))
const _5ec1a4e6 = () => interopDefault(import('../pages/questionnaires/_qreId.vue' /* webpackChunkName: "pages/questionnaires/_qreId" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/Compliance",
    component: _53833c44,
    name: "Compliance"
  }, {
    path: "/Contact",
    component: _21f22947,
    name: "Contact"
  }, {
    path: "/Controls",
    component: _73169d9f,
    name: "Controls"
  }, {
    path: "/Customers",
    component: _0979f73c,
    name: "Customers"
  }, {
    path: "/Documents",
    component: _307e37c2,
    name: "Documents"
  }, {
    path: "/KnowledgeBase",
    component: _63f252d6,
    name: "KnowledgeBase"
  }, {
    path: "/my-questionnaires",
    component: _68fc9110,
    name: "my-questionnaires"
  }, {
    path: "/Overview",
    component: _78f32ae2,
    name: "Overview"
  }, {
    path: "/SearchResults",
    component: _1196a815,
    name: "SearchResults"
  }, {
    path: "/settings",
    component: _2e537f28,
    name: "settings"
  }, {
    path: "/Subprocessors",
    component: _c1d86c70,
    name: "Subprocessors"
  }, {
    path: "/Team",
    component: _0b89be46,
    name: "Team"
  }, {
    path: "/Updates",
    component: _0340fe1e,
    name: "Updates"
  }, {
    path: "/UploadQuestions",
    component: _2048d71a,
    name: "UploadQuestions"
  }, {
    path: "/questionnaires/:qreId?",
    component: _5ec1a4e6,
    name: "questionnaires-qreId"
  }, {
    path: "/",
    component: _78f32ae2,
    alias: "/Overview",
    name: "Overview"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
